<template>
    <div id="about-mongolia">
        <p class="text">
            What<br/>
            do you know<br/>
            about Mongolia<br/>
            ?
        </p>
        <div class="arrow">
            <div class="text-left">
                <router-link to="/first-time-traveler">
                    <img :src="arrowLeft" alt="arrowLeft">
                </router-link>
            </div>
            <div class="text-right">
                <router-link to="/description-mongolia-01">
                    <img :src="arrowRight" alt="arrowRight">
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import arrowLeft from '../../assets/img/arrow-left.png'
import arrowRight from '../../assets/img/arrow-right.png'
export default {
    name: 'about-mongolia',
    data() {
        return {
            arrowLeft : arrowLeft,
            arrowRight : arrowRight
        }
    }
}
</script>

<style lang="scss" scoped>
    #about-mongolia {
        height: 100vh;
        background-image: url('../../assets/img/bg-about.png');
        background-repeat: no-repeat;
        background-size: cover;
        padding: 52px 0;
        position: relative;

        .text {
            padding: 70px 35px;
            color: #FFFFFF;
            font-size: 35px;
            font-weight: bold;
        }

        .arrow {
            display: flex;
            position: absolute;
            bottom: 20px;
            width: 100%;

            div {
                width: 50%;
            }
        }
    }
</style>


